import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";

const shortcuts = categories.filter((item) => item.key !== "all");

const accentStyles: Record<string, { wrap: string; icon: string; tag: string }> = {
  primary: {
    wrap: "bg-primary-50 text-primary-600",
    icon: "ri-film-line",
    tag: "bg-primary-100 text-primary-700",
  },
  accent: {
    wrap: "bg-accent-50 text-accent-600",
    icon: "ri-movie-2-line",
    tag: "bg-accent-100 text-accent-800",
  },
  secondary: {
    wrap: "bg-secondary-50 text-secondary-600",
    icon: "ri-fire-line",
    tag: "bg-secondary-100 text-secondary-700",
  },
};

export default function CategoryShortcuts() {
  return (
    <section aria-label="分类快捷入口">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:gap-4">
        {shortcuts.map((item) => {
          const style = accentStyles[item.key] ?? accentStyles.primary;
          const count = videos.filter((video) => video.category === item.key).length;
          return (
            <Link
              key={item.key}
              to={`/category/${item.key}`}
              className="focus-ring group flex items-center gap-3 rounded-lg border border-background-200/90 bg-white p-4 transition-colors hover:border-secondary-300 md:flex-col md:items-start md:gap-4 md:p-5"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${style.wrap}`}
              >
                <i className={`${item.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="min-w-0 flex-1 md:w-full">
                <span className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-950">{item.name}</span>
                  <span className={`rounded px-1.5 py-0.5 font-label text-[10px] font-medium ${style.tag}`}>
                    {count} 部
                  </span>
                </span>
                <span className="mt-1 block truncate text-[11px] text-foreground-500 md:line-clamp-2 md:whitespace-normal">
                  {item.description}
                </span>
              </span>
              <i
                className="ri-arrow-right-line hidden text-base text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-secondary-500 md:block"
                aria-hidden="true"
              />
            </Link>
          );
        })}
      </div>
    </section>
  );
}